import { FunctionComponent, useState } from "react";
import { Link } from "react-router-dom";

import {
  Box,
  Text,
  Stack,
  Flex,
  Avatar,
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
} from "@chakra-ui/react";
import {
  MdOutlineMenu,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdSettings,
  MdLogout,
} from "react-icons/md";
import { MdClose } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

import PremblyBrandLogo from "src/assets/images/prembly_logo.png";

import { SIDENAVS } from "src/Constant/sidenav";

type NavbarIconProps = {
  "radar-spotlight": string;
  dashboard: string;
  "check-history": string;
  "radar-check": string;
  "radar-rules": string;
  report: string;
  wallet: string;
};

type NavbarIcons = {
  [key in keyof NavbarIconProps]: string;
};

type User = {
  first_name: string;
  last_name: string;
  email: string;
  image: string;
};

type Props = {
  data: {
    user: User;
  };
};

export const Mobile_Navigation: FunctionComponent<Props> = ({ data }) => {
  const { pathname } = useLocation();
  const current_path = pathname?.split("/")[2] as keyof NavbarIcons;

  const tenant = JSON.parse(localStorage.getItem("clu")); // tlogo means, tenant logo

  const [isOpened, setIsOpened] = useState(false);
  const [isToggled, setIsToggled] = useState(false);

  const brandLogo = tenant ? tenant.tlogo : PremblyBrandLogo;

  const handleToggleSideNav = () => {
    setIsOpened(!isOpened);
  };

  const handleCloseSidenav = () => {
    setIsOpened(!isOpened);
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        p={3}
        alignItems={"center"}
        borderBottom={"1px solid rgba(0,0,0,.12)"}
        position={"fixed"}
        top={0}
        width={"100%"}
        zIndex={2}
        bg={"#fff"}
        mb={80}
      >
        <Box>
          <MdOutlineMenu onClick={handleToggleSideNav} fontSize={20} />
        </Box>
        <Text
          textTransform={"capitalize"}
          color={"tertiary"}
          fontSize={"14px"}
          fontWeight={400}
        >
          {current_path ? current_path.replace("-", " ") : ""}
        </Text>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          <Avatar
            name={data && `${data.user.first_name} ${data.user.last_name}`}
            size={"sm"}
            src={data && data.user.image}
            textTransform={"uppercase"}
          />
          <Menu closeOnBlur={false}>
            <MenuButton pt={2} onClick={handleToggle}>
              {isToggled ? (
                <MdKeyboardArrowUp fontSize={"20px"} cursor={"pointer"} />
              ) : (
                <MdKeyboardArrowDown fontSize={"20px"} cursor={"pointer"} />
              )}
            </MenuButton>
            <MenuList>
              <Text
                fontSize={"12px"}
                fontWeight={400}
                color="primary"
                p={2}
                mb={2}
                borderBottom={"1px solid rgba(0, 0, 0, 0.12)"}
              >
                {data ? data.user.email : "Hi Welcome"}
              </Text>
              <MenuItem>
                <MdSettings />
                <Text ml={2} fontSize={"13px"}>
                  Settings
                </Text>
              </MenuItem>
              <MenuItem>
                <MdLogout />
                <Text ml={2} fontSize={"13px"}>
                  Logout
                </Text>
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </Box>
      <AnimatePresence>
        {isOpened && (
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.3 }}
            style={{
              height: "100vh",
              width: "80%",
              position: "fixed",
              top: 0,
              bottom: 0,
              zIndex: 4,
              background: "#F6F3FF",
            }}
          >
            <Flex alignItems={"center"} justifyContent={"space-between"} mt={4}>
              <img
                src={brandLogo}
                style={{ width: "150px", marginLeft: "25px" }}
              />
              <MdClose
                onClick={handleToggleSideNav}
                style={{ marginRight: "1em" }}
              />
            </Flex>

            <Box
              display={"flex"}
              flexDirection={"column"}
              flex={1}
              style={{
                overflow: "scroll",
                height: "100%",
              }}
            >
              <Box w={"90%"} my={2} mx={"auto"} flex={1}>
                {SIDENAVS.map(({ name, icon, path }) => (
                  <Box
                    key={path}
                    mx={"auto"}
                    my={"1em"}
                    px={4}
                    py={2}
                    w={"100%"}
                    _hover={{ bg: "#E4DFF5", borderRadius: "24px" }}
                  >
                    <Link
                      to={`${path}`}
                      key={path}
                      onClick={handleCloseSidenav}
                    >
                      <Stack direction={"row"} alignItems={"center"}>
                        <img
                          src={icon}
                          alt={`${name} icon`}
                          style={{ width: "20px" }}
                        />
                        <Text color="primary" as={"p"} fontSize={"14px"}>
                          {name}
                        </Text>
                      </Stack>
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
